module.exports = __webpack_public_path__ + "static/media/mine-corporation-info-placeHolderImg.7c9c23914694ab4d9570d4e68469ae3d.svg";